import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'help/:topic/:faq',
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/HelpContentPageContainer'),
  }),
};
